module.exports = __webpack_public_path__ + "img/logo_85_white.59ae1120.png";